import React from "react";
import { useAuth } from "../auth/AuthContext";

/**
 * Tarjeta de indicador para los dashboards (Saldo, Ingresos, Gastos, etc.).
 * `alertaProximosAVencer` (opcional): array de { motivo, monto } de los gastos fijos
 * pendientes a 2 días o menos de su fecha de cobro (el más próximo primero). Si trae
 * algo, muestra un ícono de alerta junto a la etiqueta, con el color del `tono` de la
 * tarjeta, y el detalle de todos ellos en el tooltip (title).
 */
export default function IndicadorCard({ label, valor, tono = "neutral", icono, alertaProximosAVencer, onClick }) {
  const { monedaPredeterminada } = useAuth();
  const colorClase = { ingreso: "text-fs-ingreso", gasto: "text-fs-gasto", alerta: "text-fs-alerta", neutral: "" }[tono];

  const formatoMonto = (monto) => monto.toLocaleString("es-ES", { style: "currency", currency: monedaPredeterminada.codigo });
  const lista = alertaProximosAVencer?.length ? alertaProximosAVencer : null;
  const tooltipAlerta = lista
    ? lista.length === 1
      ? `Próximo a vencer: ${lista[0].motivo} — ${formatoMonto(lista[0].monto)}`
      : `Próximos a vencer:\n${lista.map((g) => `${g.motivo} — ${formatoMonto(g.monto)}`).join("\n")}`
    : null;

  return (
    <div
      className={`fs-card h-100${onClick ? " fs-card-clickable" : ""}`}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={onClick ? (e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onClick(); } } : undefined}
    >
      <div className="d-flex justify-content-between align-items-start">
        <div>
          <div className="fs-card-label d-flex align-items-center gap-1">
            {label}
            {tooltipAlerta && (
              <i
                className={`bi bi-exclamation-triangle-fill ${colorClase}`}
                title={tooltipAlerta}
                style={{ fontSize: ".8rem", cursor: "help" }}
                onClick={(e) => e.stopPropagation()}
              ></i>
            )}
          </div>
          <div className={`fs-card-value ${colorClase}`}>
            {typeof valor === "number"
              ? valor.toLocaleString("es-ES", { style: "currency", currency: monedaPredeterminada.codigo })
              : valor}
          </div>
        </div>
        {icono && <i className={`bi ${icono} fs-4 ${colorClase || "text-muted"}`}></i>}
      </div>
    </div>
  );
}
